module.exports = __webpack_public_path__ + "static/circle_of_stars-52cc22288aa55dbfc35f6ccf6caa6b13.png";